import { inject, provide } from 'vue';

/**
 * Creates a context with provider and consumer functions
 * @param {string} id - The context identifier
 * @returns {Array} - Array containing [provider, consumer, contextId]
 */
export function useCreateContext(id) {
  const contextId = Symbol(id);
  const provider = value => provide(contextId, value);
  const consumer = fallback => inject(contextId, fallback);

  return [provider, consumer, contextId];
}
